import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punelocalandoutstioncab() {



  const cardData = {




keyword: "Pune Local and Outstation Cab",

headingDescription: "Garud Cab Service provides dependable Pune Local and Outstation Cab services for city travel, airport transfers, railway station pickups, corporate transportation, family trips, sightseeing, and long-distance journeys from Pune to popular destinations across Maharashtra and neighboring states. Customers can book Sedan, SUV, Ertiga, Innova, Innova Crysta, Tempo Traveller, and other suitable vehicles according to their passenger and luggage requirements. Local cab services are available for business meetings, shopping, events, hotel transfers, and full-day city travel, while outstation cabs are suitable for one-way journeys, round trips, weekend trips, pilgrimages, family vacations, and customized multi-city travel. With professional chauffeurs, clean and well-maintained vehicles, flexible pickup locations, transparent pricing, comfortable seating, practical luggage space, and 24/7 customer assistance, Garud Cab Service offers convenient transportation for both local and long-distance travel.",

topPlaces: [
  {
    title: "Lonavala",
    description: "Lonavala is a popular hill destination from Pune known for waterfalls, forts, lakes, valleys, and scenic mountain surroundings. It is frequently visited by families and weekend travelers looking for a short road trip. Customers can book a comfortable private cab from Pune for direct travel, sightseeing, and convenient return arrangements."
  },
  {
    title: "Mahabaleshwar",
    description: "Mahabaleshwar is a scenic hill station famous for viewpoints, Venna Lake, strawberry farms, waterfalls, and pleasant weather. Families, couples, and groups can choose a spacious cab for a comfortable journey from Pune. Garud Cab Service provides flexible one-way and round-trip options with professional chauffeurs and customized sightseeing plans."
  },
  {
    title: "Shirdi",
    description: "Shirdi is a major pilgrimage destination known for the Sai Baba Temple and attracts devotees throughout the year. Families and senior citizens can travel comfortably from Pune in a private chauffeur-driven cab. Customers can choose one-way or round-trip service with flexible pickup timings and sufficient luggage space for a convenient religious journey."
  },
  {
    title: "Nashik",
    description: "Nashik is a popular destination for religious travel, business visits, family trips, and sightseeing, with temples, vineyards, and scenic attractions. Travelers from Pune can book a private cab for direct transportation and customize their route according to their requirements. Comfortable vehicles make the journey suitable for both small groups and families."
  },
  {
    title: "Kolhapur",
    description: "Kolhapur is known for the Mahalakshmi Temple, historic attractions, local markets, traditional cuisine, and cultural heritage. Travelers from Pune visit the city for pilgrimage, business, family functions, and sightseeing. Garud Cab Service offers suitable cabs for one-way and round-trip travel with convenient pickup and drop arrangements."
  },
  {
    title: "Satara",
    description: "Satara is surrounded by the Sahyadri ranges and provides access to attractions such as Kaas Plateau, Thoseghar Waterfalls, Ajinkyatara Fort, and scenic viewpoints. It is suitable for nature trips, family outings, and weekend travel. Customers can book a private cab from Pune with flexible sightseeing stops and customized return plans."
  },
  {
    title: "Alibaug",
    description: "Alibaug is a popular coastal getaway known for beaches, forts, resorts, and relaxing seaside experiences. Families and groups traveling from Pune can choose a private cab for comfortable transportation with sufficient luggage space. Garud Cab Service provides flexible travel schedules and customized routes for Alibaug and nearby coastal attractions."
  },
  {
    title: "Solapur",
    description: "Solapur is an important commercial and religious destination in Maharashtra and is visited for business, education, family functions, and pilgrimage travel. Customers traveling from Pune can book a private cab for direct transportation with one-way or return options. Suitable vehicle choices make the journey convenient for individuals, families, and groups."
  },
  {
    title: "Goa",
    description: "Goa is a popular long-distance destination for beach holidays, family vacations, group trips, and extended road journeys from Pune. A spacious cab provides a comfortable option for passengers traveling with luggage over the longer route. Customers can arrange one-way or round-trip chauffeur-driven transportation according to their holiday itinerary."
  },
  {
    title: "Indore",
    description: "Indore is a major city in Madhya Pradesh and is frequently visited from Pune for business, education, family travel, and cultural experiences. Travelers can book a private cab for a comfortable long-distance journey with flexible pickup arrangements. Garud Cab Service provides suitable vehicles for individuals, families, and groups traveling toward Indore."
  }
],


"services": [
{
"name": "Pune Local and Outstation Cab",
"description": "Book Pune Local and Outstation Cab for convenient transportation within Pune as well as travel to destinations outside the city. Comfortable AC vehicles with professional chauffeurs can be arranged for local trips, airport transfers, business travel, family journeys, sightseeing, and long-distance travel."
},
{
"name": "Local Cab Pune",
"description": "Choose Local Cab Pune for comfortable transportation across Pune and nearby areas. The service is suitable for office travel, shopping, appointments, railway station transfers, airport trips, family requirements, and daily local transportation with flexible pickup options."
},
{
"name": "Outstation Cab Pune",
"description": "Book Outstation Cab Pune for private chauffeur-driven travel from Pune to cities, tourist destinations, and pilgrimage locations outside the city. Sedan, SUV, Innova, and premium vehicles can be selected according to passenger count, luggage, route, and journey requirements."
},
{
"name": "City Taxi Pune",
"description": "Choose City Taxi Pune for convenient point-to-point transportation within Pune. Comfortable vehicles and professional drivers are suitable for business meetings, shopping trips, appointments, railway station travel, airport transfers, and everyday city transportation."
},
{
"name": "Pune Day Rental Cab",
"description": "Book Pune Day Rental Cab for private vehicle use throughout the day with convenient chauffeur-driven transportation. The service is suitable for multiple stops, business meetings, shopping, sightseeing, family outings, appointments, and planned city travel."
},
{
"name": "Hourly Cab Pune",
"description": "Choose Hourly Cab Pune for flexible transportation based on your required travel duration. The service is suitable for business meetings, local errands, shopping, sightseeing, appointments, multiple-location visits, and customers who prefer a cab available for several hours."
},
{
"name": "Pune Intercity Cab",
"description": "Book Pune Intercity Cab for comfortable private transportation between Pune and other cities. Professional chauffeurs and well-maintained AC vehicles are suitable for business travel, family visits, tourism, personal journeys, and scheduled intercity transportation."
},
{
"name": "Local Sightseeing Cab Pune",
"description": "Choose Local Sightseeing Cab Pune for convenient private transportation to explore attractions and popular places around Pune. The service allows flexible sightseeing arrangements for families, tourists, couples, groups, and visitors who want comfortable travel between multiple locations."
},
{
"name": "Outstation Travel Cab Pune",
"description": "Book Outstation Travel Cab Pune for comfortable long-distance journeys from Pune to destinations across Maharashtra and nearby states. Sedan, SUV, Innova, and larger vehicle options can be arranged for family trips, business travel, tourism, and pilgrimage journeys."
},
{
"name": "Pune Cab Hire Local",
"description": "Choose Pune Cab Hire Local for convenient private vehicle services within Pune and nearby areas. Customers can arrange transportation for office visits, shopping, airport transfers, railway station travel, appointments, sightseeing, and other local requirements."
},
{
"name": "Pune Cab Hire Outstation",
"description": "Book Pune Cab Hire Outstation for chauffeur-driven travel to destinations outside Pune. Comfortable vehicles can be arranged for one-way journeys, round trips, family vacations, business travel, sightseeing, religious tours, and long-distance transportation."
},
{
"name": "Full Day Cab Pune",
"description": "Choose Full Day Cab Pune for private transportation available throughout a planned day of travel. The service is suitable for corporate schedules, sightseeing, shopping, family outings, multiple appointments, city tours, and journeys requiring flexible movement between several destinations."
},
{
"name": "Half Day Cab Pune",
"description": "Book Half Day Cab Pune for convenient private transportation for a shorter planned duration. The service is suitable for local sightseeing, business meetings, shopping, airport transfers, appointments, family outings, and multiple-stop travel within Pune."
},
{
"name": "Flexible Cab Booking Pune",
"description": "Choose Flexible Cab Booking Pune for transportation arrangements based on your preferred pickup time, destination, duration, and vehicle category. The service is suitable for local travel, airport transfers, sightseeing, business requirements, family journeys, and outstation trips."
},
{
"name": "Best Local Cab Pune",
"description": "Book Best Local Cab Pune for comfortable and convenient transportation across the city with professional chauffeurs and well-maintained vehicles. The service is suitable for daily travel, business visits, airport transfers, shopping, appointments, and family transportation."
},
{
"name": "Pune Local and Outstation Cab",
"description": "Choose Pune Local and Outstation Cab for a complete transportation option covering both city travel and longer journeys outside Pune. Sedan, SUV, Innova, and premium vehicles can be arranged for local requirements, airport transfers, business travel, family trips, and outstation routes."
},
{
"name": "Local and Outstation Cab Service Pune",
"description": "Book Local and Outstation Cab Service Pune for convenient chauffeur-driven transportation within Pune and to destinations outside the city. The service is suitable for daily travel, sightseeing, airport transfers, corporate journeys, family trips, tourism, and long-distance travel."
},
{
"name": "Pune Cab Service for Local and Outstation",
"description": "Choose Pune Cab Service for Local and Outstation travel when you need one transportation solution for city and intercity journeys. Comfortable AC vehicles can be selected for office travel, airport transfers, family outings, sightseeing, business trips, and outstation destinations."
},
{
"name": "Best Local and Outstation Cab Pune",
"description": "Book Best Local and Outstation Cab Pune for reliable private transportation across Pune and to destinations outside the city. Professional chauffeurs and multiple vehicle categories make the service suitable for individuals, families, corporate travelers, tourists, and groups."
},
{
"name": "24x7 Local and Outstation Taxi Pune",
"description": "Choose 24x7 Local and Outstation Taxi Pune for transportation support across different travel schedules. The service is suitable for early-morning airport trips, late-night journeys, local travel, business requirements, family transportation, and long-distance outstation routes."
},
{
"name": "Cheap Local and Outstation Cab Pune",
"description": "Book Cheap Local and Outstation Cab Pune for economical transportation within Pune and to selected outstation destinations. Practical sedan, SUV, and other vehicle options can be arranged for individuals, families, students, business travelers, and budget-conscious passengers."
},
{
"name": "Online Local and Outstation Cab Booking Pune",
"description": "Choose Online Local and Outstation Cab Booking Pune for convenient advance reservation of local and intercity transportation. Customers can select pickup details, destination, travel timing, vehicle category, passenger count, and luggage requirements according to their journey."
},
{
"name": "Pune Local Taxi and Outstation Service",
"description": "Book Pune Local Taxi and Outstation Service for private transportation covering city travel as well as longer intercity journeys. Comfortable AC vehicles and professional chauffeurs can be arranged for airport transfers, sightseeing, business travel, family trips, and pilgrimage routes."
},
{
"name": "Pune City and Outstation Cab",
"description": "Choose Pune City and Outstation Cab for convenient transportation within Pune and to destinations outside the city. The service supports local trips, airport transfers, business travel, sightseeing, family journeys, one-way travel, and round-trip outstation requirements."
},
{
"name": "Pune to Mumbai Cab",
"description": "Book Pune to Mumbai Cab for comfortable private transportation between Pune and Mumbai. The service is suitable for business travelers, families, tourists, airport passengers, and individuals requiring direct intercity travel with professional chauffeur assistance."
},
{
"name": "Pune to Shirdi Taxi",
"description": "Choose Pune to Shirdi Taxi for convenient private transportation to Shirdi. The service is suitable for Sai Baba devotees, families, tourists, senior passengers, and groups planning comfortable pilgrimage travel with flexible one-way or return journey options."
},
{
"name": "Pune to Goa Cab",
"description": "Book Pune to Goa Cab for comfortable long-distance transportation from Pune to Goa. Sedan, SUV, Innova, and larger vehicle options can be arranged for families, couples, groups, corporate travelers, and tourists planning a private road journey."
},
{
"name": "Pune to Mahabaleshwar Taxi",
"description": "Choose Pune to Mahabaleshwar Taxi for convenient private transportation to the hill station. The service is suitable for families, couples, tourists, and weekend travelers looking for comfortable AC travel with direct pickup and destination drop."
},
{
"name": "Pune to Nashik Cab",
"description": "Book Pune to Nashik Cab for comfortable intercity transportation from Pune to Nashik. The service is suitable for business travel, family visits, tourism, religious journeys, and personal trips with professional chauffeurs and well-maintained AC vehicles."
},
{
"name": "Pune to Kolhapur Taxi",
"description": "Choose Pune to Kolhapur Taxi for convenient long-distance travel between Pune and Kolhapur. Comfortable sedan, SUV, and spacious vehicle options can be arranged for families, business travelers, tourists, and passengers traveling for personal or religious purposes."
},
{
"name": "Pune Airport to City Cab",
"description": "Book Pune Airport to City Cab for convenient transportation from Pune Airport to residential, hotel, commercial, and business locations across the city. The service is suitable for arriving passengers, families, corporate travelers, tourists, and passengers carrying luggage."
},
{
"name": "Pune to Lonavala Cab",
"description": "Choose Pune to Lonavala Cab for comfortable private travel to Lonavala. The service is suitable for weekend trips, families, couples, tourists, and groups looking for convenient transportation for sightseeing and leisure travel."
},
{
"name": "Pune to Mumbai Cabs",
"description": "Book Pune to Mumbai Cabs for convenient private transportation between Pune and Mumbai with vehicle choices suited to different passenger requirements. The service is suitable for airport travel, corporate journeys, family visits, tourism, and personal trips."
},
{
"name": "Pune to Mumbai Airport Cab",
"description": "Choose Pune to Mumbai Airport Cab for direct airport transportation from Pune to Mumbai Airport. Comfortable AC vehicles with professional chauffeurs are suitable for business travelers, families, tourists, and passengers requiring scheduled airport drop service."
},
{
"name": "Pune to Nashik Cab",
"description": "Book Pune to Nashik Cab for convenient private transportation between Pune and Nashik. The service is suitable for corporate travel, family journeys, tourism, religious visits, personal work, and passengers looking for direct chauffeur-driven intercity travel."
},
{
"name": "Pune to Shirdi Cab",
"description": "Choose Pune to Shirdi Cab for comfortable pilgrimage transportation from Pune to Shirdi. The service is suitable for devotees, families, tourists, senior passengers, and groups requiring private travel with convenient pickup and destination drop."
},
{
"name": "Pune to Aurangabad Cab",
"description": "Book Pune to Aurangabad Cab for comfortable intercity travel between Pune and Aurangabad. Professional chauffeurs and AC vehicles make the service suitable for business trips, family visits, tourism, heritage travel, and personal journeys."
},
{
"name": "Pune to Goa Cab",
"description": "Choose Pune to Goa Cab for a convenient private road journey from Pune to Goa. Multiple vehicle categories can be arranged for families, couples, tourist groups, corporate travelers, and passengers planning a comfortable long-distance trip."
},
{
"name": "Pune to Alibaug Cab",
"description": "Book Pune to Alibaug Cab for comfortable private transportation to Alibaug. The service is suitable for weekend travelers, families, couples, tourists, and groups planning beach trips, leisure travel, sightseeing, and short getaways."
},
{
"name": "Pune to Mahabaleshwar Cab",
"description": "Choose Pune to Mahabaleshwar Cab for convenient transportation to Mahabaleshwar with direct pickup from Pune. Comfortable AC vehicles are suitable for families, couples, tourists, and groups planning hill-station holidays and sightseeing."
},
{
"name": "Pune to Lonavala Cab",
"description": "Book Pune to Lonavala Cab for private transportation to Lonavala with comfortable seating and professional chauffeur service. The cab is suitable for weekend travel, family outings, couples, tourists, and groups visiting nearby attractions."
},
{
"name": "Pune to Kolhapur Cab",
"description": "Choose Pune to Kolhapur Cab for comfortable intercity transportation with convenient pickup from Pune. The service is suitable for business travelers, families, tourists, and passengers traveling for personal, cultural, or religious purposes."
},
{
"name": "Pune to Satara Cab",
"description": "Book Pune to Satara Cab for convenient private transportation between Pune and Satara. Sedan, SUV, and spacious vehicle options can be arranged for business travel, family visits, sightseeing, personal journeys, and local-area travel requirements."
},
{
"name": "Pune to Sangli Cab",
"description": "Choose Pune to Sangli Cab for comfortable long-distance transportation from Pune to Sangli. The service is suitable for families, corporate travelers, tourists, and individuals requiring private travel with professional chauffeur assistance."
},
{
"name": "Pune to Solapur Cab",
"description": "Book Pune to Solapur Cab for direct and comfortable transportation between Pune and Solapur. The service is suitable for business trips, family journeys, personal visits, tourism, and long-distance travel with suitable vehicle options."
},
{
"name": "Pune to Latur Cab",
"description": "Choose Pune to Latur Cab for convenient private transportation from Pune to Latur. Comfortable AC vehicles and professional chauffeurs are suitable for families, business travelers, tourists, personal visits, and passengers planning long-distance journeys."
},
{
"name": "Pune to Pandharpur Cab",
"description": "Book Pune to Pandharpur Cab for comfortable private pilgrimage transportation to Pandharpur. The service is suitable for devotees, families, senior passengers, and groups planning temple visits with convenient one-way or round-trip travel arrangements."
},
{
"name": "Pune to Akkalkot Cab",
"description": "Choose Pune to Akkalkot Cab for convenient private travel to Akkalkot for pilgrimage and personal visits. Comfortable vehicles with professional chauffeurs can be arranged for devotees, families, senior passengers, and groups."
},
{
"name": "Pune to Bhimashankar Cab",
"description": "Book Pune to Bhimashankar Cab for comfortable transportation to the Bhimashankar Jyotirlinga. The service is suitable for devotees, families, tourists, and groups planning a religious journey with convenient pickup, temple travel, and return options."
},
{
"name": "Pune to Grishneshwar Cab",
"description": "Choose Pune to Grishneshwar Cab for convenient private pilgrimage transportation to Grishneshwar Jyotirlinga. The service is suitable for devotees, families, tourists, and groups looking for comfortable long-distance travel with professional chauffeur assistance."
},
{
"name": "Pune to Jyotirlinga Cab",
"description": "Book Pune to Jyotirlinga Cab for private transportation to selected Jyotirlinga pilgrimage destinations. Sedan, SUV, Innova, and larger vehicles can be arranged for devotees, families, senior passengers, and groups planning religious road trips."
},
{
"name": "Pune Ashtavinayak Cab Package",
"description": "Choose Pune Ashtavinayak Cab Package for convenient private transportation covering planned Ashtavinayak temple visits. Comfortable vehicles with professional chauffeurs can be arranged for families, devotees, tourists, and groups requiring flexible sightseeing and pilgrimage travel."
}
],
"tableData": [
["Pune Local and Outstation Cab", "Local Cab Pune"],
["Outstation Cab Pune", "City Taxi Pune"],
["Pune Day Rental Cab", "Hourly Cab Pune"],
["Pune Intercity Cab", "Local Sightseeing Cab Pune"],
["Outstation Travel Cab Pune", "Pune Cab Hire Local"],
["Pune Cab Hire Outstation", "Full Day Cab Pune"],
["Half Day Cab Pune", "Flexible Cab Booking Pune"],
["Best Local Cab Pune", "Pune Local and Outstation Cab"],
["Local and Outstation Cab Service Pune", "Pune Cab Service for Local and Outstation"],
["Best Local and Outstation Cab Pune", "24x7 Local and Outstation Taxi Pune"],
["Cheap Local and Outstation Cab Pune", "Online Local and Outstation Cab Booking Pune"],
["Pune Local Taxi and Outstation Service", "Pune City and Outstation Cab"],
["Pune to Mumbai Cab", "Pune to Shirdi Taxi"],
["Pune to Goa Cab", "Pune to Mahabaleshwar Taxi"],
["Pune to Nashik Cab", "Pune to Kolhapur Taxi"],
["Pune Airport to City Cab", "Pune to Lonavala Cab"],
["Pune to Mumbai Cabs", "Pune to Mumbai Airport Cab"],
["Pune to Nashik Cab", "Pune to Shirdi Cab"],
["Pune to Aurangabad Cab", "Pune to Goa Cab"],
["Pune to Alibaug Cab", "Pune to Mahabaleshwar Cab"],
["Pune to Lonavala Cab", "Pune to Kolhapur Cab"],
["Pune to Satara Cab", "Pune to Sangli Cab"],
["Pune to Solapur Cab", "Pune to Latur Cab"],
["Pune to Pandharpur Cab", "Pune to Akkalkot Cab"],
["Pune to Bhimashankar Cab", "Pune to Grishneshwar Cab"],
["Pune to Jyotirlinga Cab", "Pune Ashtavinayak Cab Package"]
],



whychoose: [
  {
    WhyChooseheading: "Pune Local and Outstation Cab for Complete Travel Needs",
    WhyChoosedescription: "From everyday city transportation to longer journeys outside Pune, travellers can arrange private cab services suited to airport transfers, business trips, family travel, sightseeing, and intercity transportation."
  },
  {
    WhyChooseheading: "Convenient Local Travel Across Pune",
    WhyChoosedescription: "Homes, offices, hotels, railway stations, commercial areas, and other preferred locations can be connected through convenient point-to-point taxi arrangements within Pune."
  },
  {
    WhyChooseheading: "Outstation Trips from Pune Made Convenient",
    WhyChoosedescription: "Popular destinations including Mumbai, Lonavala, Mahabaleshwar, Nashik, Shirdi, Goa, Satara, Kolhapur, and other cities can be covered through planned outstation cab bookings."
  },
  {
    WhyChooseheading: "Vehicle Choices for Different Groups",
    WhyChoosedescription: "Individuals, couples, families, and groups can select an appropriate vehicle based on passenger numbers, luggage requirements, journey duration, and desired level of comfort."
  },
  {
    WhyChooseheading: "Airport & Railway Station Transfers",
    WhyChoosedescription: "Scheduled transportation to and from Pune Airport or Pune Railway Station can be arranged for arriving passengers, departing travellers, families, and business professionals."
  },
  {
    WhyChooseheading: "Corporate Transportation Solutions",
    WhyChoosedescription: "Companies can use local and outstation cabs for employee movement, client pickups, meetings, conferences, office transfers, industrial visits, and business travel requirements."
  },
  {
    WhyChooseheading: "One-Way & Round-Trip Options",
    WhyChoosedescription: "Depending on the itinerary, passengers can choose a direct one-way journey or reserve a round-trip cab for return travel, sightseeing, family visits, and extended road trips."
  },
  {
    WhyChooseheading: "Easy Travel Planning with Garud Cab Service",
    WhyChoosedescription: "Share your pickup point, destination, travel date, passenger count, luggage details, vehicle preference, and trip type to get assistance in arranging a suitable Pune local or outstation cab."
  }
]


};


const faqData = [
  {
    question: "Does Garud Cab Service provide local and outstation cabs in Pune?",
    answer: "Yes, Garud Cab Service offers cab arrangements for local Pune transportation as well as outstation journeys to various cities, tourist destinations, and pilgrimage locations."
  },
  {
    question: "Can I book a local cab anywhere in Pune?",
    answer: "Yes, pickup can be arranged from homes, hotels, offices, residential societies, railway station areas, commercial locations, and other preferred places within Pune."
  },
  {
    question: "Which outstation destinations can I travel to from Pune?",
    answer: "Outstation cab services can be arranged for destinations such as Mumbai, Lonavala, Mahabaleshwar, Nashik, Shirdi, Goa, Satara, Kolhapur, and many other locations."
  },
  {
    question: "Can I book a one-way outstation cab from Pune?",
    answer: "Yes, one-way cab service can be arranged when you need direct transportation from Pune to your selected outstation destination without requiring the vehicle for the return."
  },
  {
    question: "Are round-trip cabs available from Pune?",
    answer: "Yes, round-trip cabs can be arranged for sightseeing, family visits, business travel, weekend trips, pilgrimage journeys, and other planned return journeys."
  },
  {
    question: "Can I book a Pune Airport cab?",
    answer: "Yes, local taxi arrangements can be made for Pune Airport pickup and drop services according to your flight timing and preferred pickup or destination location."
  },
  {
    question: "Do you provide Pune Railway Station cab service?",
    answer: "Yes, cab transportation can be arranged for Pune Railway Station pickups and drops from homes, hotels, offices, and other preferred locations."
  },
  {
    question: "Is the service suitable for corporate travel?",
    answer: "Yes, local and outstation cab services can support corporate requirements such as employee transportation, client travel, meetings, conferences, office transfers, and industrial visits."
  },
  {
    question: "Can families travel with luggage?",
    answer: "Yes, families and groups can select a suitable vehicle based on passenger numbers and luggage requirements for both local and outstation journeys."
  },
  {
    question: "How can I book a Pune Local and Outstation Cab?",
    answer: "Share your pickup location, destination, travel date, passenger details, luggage requirements, preferred vehicle, and one-way or round-trip preference with Garud Cab Service."
  }
];


const testimonials = [
  {
    id: 1,
    name: "Mr. Rahul Deshmukh",
    feedback: "We needed a cab for both local Pune travel and an outstation family trip. Having one service for different travel requirements made our planning much simpler.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Meenal Joshi",
    feedback: "I arranged a Pune cab for an airport transfer and later used the service for an outstation journey. The private travel option was convenient for our family and luggage.",
    rating: 5
  }
];


















  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Pune to Mumbai Airport Cab",
      link: "pune-to-mumbai-airport-cab-service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Pune to Outstation Cabs",
      link: "Pune-to-Outstation-Cabs",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Pune to Mahabaleshwar Cab",
      link: "pune-to-mahabaleshwar-cab-service",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Pune to Lonavala Cab",
      link: "pune-to-lonavala-cab-service",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Pune to Matheran Cabs",
      link: "pune-to-matheran-cab-service",
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Pune to 5 Jyotirlinga Darshan Cab",
      link: "pune-to-5-jyotirlinga-cab-service",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Pune to Bhimashankar Cab",
      link: "pune-to-bhimashankar-cab-service",
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Pune to Aurangabad Cab Service",
      link: "Pune-to-Aurangabad-Cab-Service",
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Pune to Nashik Cab Service",
      link: "Pune-to-Nashik-Cab-Service",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Pune to Kolhapur Cab Service",
      link: "Pune-to-Kolhapur-Cab-Service",
    },
    {
      place: "/images/keyword/11.jpg",
      text: "Pune to Alibaug Cab",
      link: "Pune-to-Alibaug-Cab",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/13.jpg",
      text: "Goa to Pune Cabs",
      link: "Goa-to-Pune-Cabs",
    },
    {
      place: "/images/keyword/14.jpg",
      text: "Innova Crysta Cab in Pune",
      link: "Innova-Crysta-Cab-in-Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Ertiga On Rent in Pune",
      link: "Ertiga-On-Rent-in-Pune",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Ashtavinayak Cabs",
      link: "pune-to-ashtavinayak-cab-service",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Goa Cabs",
      link: "Pune-to-Goa-Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Jyotirlinga Darshan Package",
      link: "Pune-to-Jyotirlinga-Darshan-Package",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Akkalkot Cabs",
      link: "Pune-to-Akkalkot-Cabs",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Pandharpur Cab",
      link: "Pune-to-Pandharpur-Cab",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Grishneshwar Jyotirlinga Cab",
      link: "Pune-to-Grishneshwar-Jyotirlinga-Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Mumbai Cabs",
      link: "pune-to-mumbai-cab-service",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Alibag Cab",
      link: "Pune-to-Alibag-Cab",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Innova Crysta On Rent in Pune",
      link: "Innova-Crysta-On-Rent-in-Pune",
    },

  ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune Local and Outstation Cab",
  "image": "https://garudcabs.com/assets/images/pune-local-and-outstation-cab.webp",
  "description": "Book Pune Local and Outstation Cab services with Garud Cab for convenient city travel, sightseeing, airport transfers, hourly rentals, day rentals, and intercity journeys. Choose comfortable Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs for local Pune travel, outstation trips, family tours, business travel, one way drops, and round trip transportation.",
  "brand": {
    "@type": "Brand",
    "name": "Garud Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7934"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://garudcabs.com/pune-local-and-outstation-cab"
  }
};





  return (
    <div>

<Helmet>
  <title>Pune Local & Outstation Cab | City Taxi & Rental | +91 9970007784</title>

  <meta
    name="description"
    content="Book Pune Local and Outstation Cab with Garud Cab for city travel, sightseeing, hourly rental, day rental, airport transfers, and intercity journeys. Get reliable local and outstation taxi services with Sedan, Ertiga, SUV, Innova, and Innova Crysta options."
  />

  <meta
    name="keywords"
    content="Pune Local and Outstation Cab, Local Cab Pune, Outstation Cab Pune, City Taxi Pune, Pune Day Rental Cab, Hourly Cab Pune, Pune Intercity Cab, Local Sightseeing Cab Pune, Pune Local Taxi Service, Pune Outstation Taxi Service, Pune Cab Rental"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>




      <section className="page-banner">
        <div className="page-banner-container">
          <h2>
            {cardData.keyword}
          </h2>
        </div>
      </section>








      <section>
        <div className="container-fluid p-0" >
          <div className="row container-fluid px-md-2">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/80.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Garud Cabs Services: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>





              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>



              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-dark">
                  Why Choose <span>Garud Cabs Services</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Garud Cabs Services </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919970007784 " className="pc-call">+91 9970007784 </a>
                    </div>
                    <div className="pc-list">
                      <a href="tel:+919970353709 " className="pc-call">+91 9970353709 </a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919970007784 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919970007784 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@garudcabs.com" className="pc-email">
                      booking@garudcabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Garud Cabs Services</strong><br />
                      Office No.101 Anand Heights
                      Chandan Nagar, Kharadi, Pune,
                      Maharashtra, India-  411014




                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punelocalandoutstioncab;